// Which booking flow the customer gets: Book & pay, the only one left.
//
//   book-and-pay – Wash → Book & pay (details, a row of extras chips and the
//                  payment panel on one screen, /booking/book)
//
// This used to be a PostHog experiment (flag `booking-flow`, 50/50) against
// a 4-step control (Wash → Details → Extras → Checkout). It was retired on
// 2026-10-04: everyone gets book-and-pay. The arm could never be read
// (`posthog.reset()` wiped the cached flag mid-funnel, so 0 orders were ever
// stamped book-and-pay) and could never have resolved (~32 months for the
// lift it was designed to find). docs/DECISIONS.md 2026-10-04,
// docs/ANALYTICS_REVIEW_2026-10-02.md §3.
//
// The control screens stayed routed behind a `?booking_flow=control` preview
// override until 2026-10-12, when they were deleted: /booking/details still
// served the old form to visitors from old links (26 in 30 days) and the
// override had no use left. Every retired step URL now 301s to /booking/book
// (config/routes.rb) and the SPA redirects them too (pages/booking).

export const FLOW = { BOOK_AND_PAY: 'book-and-pay' }

// Still sent as `form_variant` on the Book & pay progress events, so the
// series reads the same before and after.
export const bookingFlowVariant = () => FLOW.BOOK_AND_PAY

// Where a wash tile sends the customer, query kept.
export const firstBookingStepPath = (search = '') => `/booking/book${search}`
